<nav class="day-selector" [ngClass]="{ 'justify-content-center': justifyContentPosition === 'center', 'justify-content-space-between': justifyContentPosition === 'space-between' }" [class.playlist-col]="playlistMode">
  <button
    class="btn-day"
    *ngFor="let day of days.slice(0, 7)"
    [disabled]="activeDay == 24"
    (click)="daySelected.emit(day)"
  >
    <span
      [class.today]="today == day"
      [class.selected]="activeDay == day"
      class="day-letter"
      >{{ day | translate | uppercase | slice: 0:1 }}</span
    >
  </button>
</nav>
